/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import OkC from "shared/util/OkcApi";
import Context from "shared/util/Context";
import OkInstagram from "shared/modules/OkInstagram";

//#####################
/* PHOTO UPLOADER */
//#####################

window.PhotoUploader = {
	// constants for which uploader rules to show
	ruleTypes: {
		profile: "profile",
		album: "album",
		STORIES_ESSAY_ATTACHMENTS: "STORIES_ESSAY_ATTACHMENTS",
	},

	// Photo upload settings
	minSize: 400,

	uploadSource: "pc",

	// Album info
	albumid: 0,

	// Photo Source ("essays", "profile", etc)
	source: "profile",

	// Tile stuff
	albumLimit: 20,

	// Initialize the uploader.
	init() {
		if (this.initialized) {
			return;
		}

		this.uploadContainer = $("#okphotos_upload");
		this.serviceContainer = $("#service_picker");
		this.uploadComputerBtn = $("#service_computer");
		this.uploadFacebookBtn = $("#service_facebook");
		this.uploadDropboxBtn = $("#service_dropbox");
		this.uploadInstagramBtn = $("#service_instagram");
		this.iframeContainer = $("#iframe_container");
		this.photoUploadForm = $("#okphotos_upload_form");
		this.photoInput = $("#okphotos_file_input");
		this.dragndrop = $("#okphotos_dragndrop");
		this.rules = $("#okphotos_rules");

		// set initial rules style
		if (
			(typeof ProfilePhotos !== "undefined" && ProfilePhotos !== null
				? ProfilePhotos.current_album
				: undefined) != null &&
			(typeof ProfilePhotos !== "undefined" && ProfilePhotos !== null
				? ProfilePhotos.current_album
				: undefined) !== "0" ||
			this.source === "album"
		) {
			this.setRules(this.ruleTypes.album);
		} else if (this.source === "essays") {
			this.setRules(this.ruleTypes.STORIES_ESSAY_ATTACHMENTS);
		} else {
			this.setRules(this.ruleTypes.profile);
		}

		this.uploadComputerBtn.on("click tap", ev => {
			ev.preventDefault();
			this.uploadSource = "pc";
			this.photoInput[0].value = null;
			this.photoInput.click();
		});

		this.uploadFacebookBtn.on("click tap", () => {
			this.openFacebook();
		});

		this.uploadDropboxBtn.on("click tap", () => {
			this.openDropbox();
		});

		this.uploadInstagramBtn.on("click tap", () => {
			this.openInstagram();
		});

		this.photoInput.on("change", () => {
			this.uploadFile();
		});

		// Set up drag and drop
		if (OkPhotos.support.dragndrop) {
			this.initDragndrop();
		}

		// Set up FB
		if (!OkFB.connected) {
			OkFB.init(() => {
				OkFB.checkConnected(() => {
					if (OkFB.connected) {
						ClientStats.update({ statname: "OkPhotos - facebook - existing token" });
					}
				});
			});
		}

		// Set up user tips
		$("#okphotos_rules a").on("click tap", () => {
			$("#okphotos_rules").addClass("show_more");
		});

		this.initialized = true;
	},

	/* Drag and drop */

	initDragndrop() {
		$("#okphotos_upload").addClass("dragndrop");

		this.dragndrop.on("dragenter dragover", e => {
			e.preventDefault();
			e.stopPropagation();
			this.uploadContainer.addClass("drag_over");
		});

		this.dragndrop.on("dragleave dragend", e => {
			e.preventDefault();
			e.stopPropagation();
			this.uploadContainer.removeClass("drag_over");
		});

		this.dragndrop.on("drop", e => {
			e.preventDefault();
			e.stopPropagation();
			this.uploadContainer.removeClass("drag_over");
			let file = e.originalEvent.dataTransfer.files[0];

			if (file) {
				this.uploadSource = "dragdrop";
				OkPhotos.showLoader();
				PhotoUtil.ajaxUpload({
					file,

					success: response => {
						this.upload_cb(response);
					},

					error: response => {
						this.handleFileError(response);
					},
				});
			}
		});
	},

	/* Dropbox */

	// Opens the dropbox dialog.
	//
	openDropbox() {
		this.uploadSource = "dropbox";
		OkPhotos.showLoader();

		Dropbox.choose({
			linkType: "direct",
			multiselect: false,
			extensions: [".jpg", ".jpeg", ".png", ".gif"],

			success: files => {
				let { name } = files[0];
				let src = files[0].link;
				let type = name.split(".");
				type = type[type.length - 1].toLowerCase() || "";

				if (!$.inArray(type, this.fileTypes)) {
					OkPhotos.showError(PhotoUtil.ERRORS.FILE_TYPE);
					return false;
				}

				PhotoUtil.uploadUrl({
					url: src,

					success: response => {
						this.upload_cb(response);
					},

					error: () => {
						OkPhotos.showError();
					},
				});
			},

			cancel() {
				OkPhotos.hideLoader();
			},
		});
	},

	/* Facebook */

	// Opens whatever represents a user's facebook images.
	openFacebook() {
		this.uploadSource = "facebook";
		OkPhotos.showLoader();
		let firstAuth = !OkFB.connected;

		if (firstAuth) {
			ClientStats.update({ statname: "OkPhotos - facebook - dialogue shown" });
		}

		OkFB.connect("user_birthday,user_photos", response => {
			if (!OkFB.connected) {
				ClientStats.update({ statname: "OkPhotos - facebook - dialogue canceled" });
				OkPhotos.hideLoader();
				return;
			}

			if (firstAuth) {
				ClientStats.update({ statname: "OkPhotos - facebook - dialogue approved" });
			}

			this.loadFacebookAlbums();
		});
	},

	// Load all of a user's available facebook albums to choose from.
	loadFacebookAlbums(offset, cb) {
		if (offset == null) {
			offset = 0;
		}

		if (!offset) {
			this.albumOffset = 0;
		}

		// This is kind of a fake FB api endpoint that can be found in
		// public_api/apps/social.pub. Combines a LOT of endpoint hitting to
		// assemble albums into one tidy endpoint.
		OkC.api("/social/fb/albums", {
			api: 1,
			data: {
				limit: this.albumLimit,
				offset,
			},

			success: response => {
				if (!this.checkFbError(response)) {
					return;
				}

				this.albumOffset += response.data.length;
				const tiles = [];

				for (let album of response.data) {
					let tile = this.albumToTile(album);

					if (tile) {
						tiles.push(tile);
					}
				}

				if (offset > 0) {
					PhotoTiles.addTile(tiles);
				} else {
					PhotoTiles.loadTileSet({
						service: "facebook",
						title: _str("Select an Album"),
						tiles,
					});
					PhotoTiles.scrollCallback = () => {
						this.facebookAlbumScrollHandler();
					};
					OkPhotos.switchAction("photo_tiles");
				}

				if (cb) {
					cb(tiles);
				}
			},
		});
	},

	// Converts FB api albums to tiles. Empty or thumbless albums are out.
	albumToTile(album) {
		if (album.count === 0 || !album.thumb) {
			return false;
		}

		let tile = {
			id: `album_${album.id}`,
			album_id: album.id,
			title: album.name,
			thumb: album.thumb,
			onclick: album => {
				this.loadFacebookAlbumPhotos(album);
			},
		};

		if (tile.thumb) {
			tile.thumb = tile.thumb.replace("720x720", "350x350");
		}

		if (album.count) {
			tile.description = _strf("$count photos", { count: album.count });
		}

		return tile;
	},

	// Check against FB api requests for errors.
	checkFbError(response) {
		if (response.error) {
			if (response.error.code && response.error.code === 190) {
				this.openFacebook();
			} else {
				OkPhotos.showError(PhotoUtil.ERRORS.SOCIAL);
			}

			return false;
		}

		return true;
	},

	// Load in an album's photos to the tile viewer.
	loadFacebookAlbumPhotos(album, offset, cb) {
		if (offset == null) {
			offset = 0;
		}

		if (!offset) {
			this.albumOffset = 0;
			OkPhotos.showLoader();
		}

		this.currentAlbum = album;
		this.albumEndpoint = `/${album.album_id}/photos`;

		OkFB.api(
			this.albumEndpoint,
			{
				fields: "id,source,width,height",
				limit: this.albumLimit,
				offset,
			},
			response => {
				if (!this.checkFbError(response)) {
					return;
				}

				this.albumOffset += response.data.length;
				let tiles = [];

				for (let photo of response.data) {
					let thumb = photo.source.replace(/\/(\w*\.\w*)$/g, "/p200x200/$1");
					thumb = thumb.replace("_a.jpg", "_n.jpg");

					let tile = {
						id: `photo_${photo.id}`,
						source: photo.source,
						thumb,
						subtile: true,
					};

					if (photo.width < this.minSize || photo.height < this.minSize) {
						tile.classes = "too_small";
						tile.disabled = true;
					}

					tiles.push(tile);
				}

				if (offset > 0) {
					PhotoTiles.addTile(tiles);
				} else {
					PhotoTiles.loadSubtileSet(tiles, _str("Back to Albums"));
				}

				if (cb) {
					cb(tiles);
				}
			},
		);
	},

	facebookAlbumScrollHandler() {
		// Load more images
		if (PhotoTiles.showingSubtiles) {
			this.loadFacebookAlbumPhotos(
				this.currentAlbum,
				this.albumOffset,
				this.tileScroll_cb
			);
			// Load more albums
		} else {
			this.loadFacebookAlbums(this.albumOffset, this.tileScroll_cb);
		}
	},

	/* Instagram */

	// Auth and load instagram tileset
	openInstagram() {
		this.uploadSource = "instagram";
		OkPhotos.showLoader();

		OkInstagram.init(() => {
			OkInstagram.api(
				"/users/self/media/recent",
				{
					// TODO DEPRECATE once switch to new api
					count: this.albumLimit,
				},
				response => {
					if (response && response.data) {
						if (response.data.length) {
							this.loadInstagramPhotos(response.data);
						} else {
							OkPhotos.showError(PhotoUtil.ERRORS.NO_PHOTOS);
						}
					} else {
						OkPhotos.showError(PhotoUtil.ERRORS.SOCIAL);
					}
				},
			);
		});
	},

	// Take in photos from instagram api, convert to tiles
	loadInstagramPhotos(photos, add, cb) {
		let tiles = [];
		for (let photo of photos) {
			tiles.push({
				id: `instagram_photo_${photo.id}`,
				thumb: photo.images.low_resolution.url,
				source: photo.images.standard_resolution.url,
			});
		}

		if (add) {
			PhotoTiles.addTile(tiles);
		} else {
			PhotoTiles.loadTileSet({
				service: "instagram",
				title: _str("Select a Photo"),
				tiles,
			});

			PhotoTiles.scrollCallback = () => {
				this.instagramScrollHandler();
			};

			OkPhotos.switchAction("photo_tiles");
		}

		typeof cb === "function" ? cb(tiles) : undefined;
	},

	instagramScrollHandler() {
		let maxId = PhotoTiles.tileHolder.find(".photo_tile").last().attr("id");
		maxId = maxId.replace("instagram_photo_", "");

		OkInstagram.api(
			"/users/self/media/recent",
			{
				max_id: maxId,
			},
			response => {
				this.loadInstagramPhotos(
					response.data,
					true,
					this.tileScroll_cb
				);
			},
		);
	},

	/* Helper functions */

	// Uploads a file that's in the photo upload form.
	uploadFile() {
		PhotoUtil.uploadFileForm({
			form: $("#okphotos_upload_form"),

			success: response => {
				this.upload_cb(response);
			},

			error: response => {
				this.handleFileError(response);
			},

			complete: () => {
				// Clear out the input in case they re-add the same file.
				$("#okphotos_upload_form input").val("");
			},
		});
	},

	handleFileError(response) {
		let errorType = null;

		if ((response != null ? response.statusText : undefined) === "timeout") {
			errorType = PhotoUtil.ERRORS.TIMEOUT;
		} else if ((response != null ? response.status : undefined) === 413) {
			errorType = PhotoUtil.ERRORS.TOO_LARGE;
		} else if (response != null ? response.error : undefined) {
			errorType = response.error;
		}

		OkPhotos.showError(errorType);
	},

	// Generic callback that handles the /ajaxuploader response. Set up the
	// editor to move on with the image you just uploaded.
	upload_cb(response) {
		clearTimeout(this.iframeTimeout);

		if (response.error) {
			OkPhotos.showError(response.error);
			return false;
		}

		// Build the photo object
		this.photo = {
			id: response.id,
			url: response.url,
			width: response.width,
			height: response.height,
		};

		ClientStats.update({
			statnames: [
				"OkPhotos - photo uploaded",
				`OkPhotos - photo uploaded from ${this.uploadSource}`,
			],
		});
		window.util.updateStats(
			"OkPhotos - average photo width",
			this.photo.width,
			"value",
			"d9ioz+JywPawOgFKIf3cS1y0TCs="
		);
		window.util.updateStats(
			"OkPhotos - average photo height",
			this.photo.height,
			"value",
			"yG7wXe08gF9qRbT7l5+W3Zsjcic="
		);

		// Trigger any okphotos.picked events. If one of the callbacks called
		// OkPhotos.close(), let it do its thang.
		$(document).trigger({
			type: "okphotos.picked",
			photo: this.photo,
		});

		if (!OkPhotos.isOpen()) {
			return;
		}

		// If the editor wasn't initialized or was disabled, we assume that someone
		// fired this up just to get at the callback.
		if (PhotoEditor.initialized && !PhotoEditor.disabled) {
			this.loadPhotoEditor();
		} else {
			OkPhotos.close();
		}
	},

	loadPhotoEditor() {
		PhotoEditor.loadPhoto(this.photo, () => {
			OkPhotos.switchAction("edit", 1);
			PhotoEditor.changeState("crop");
			setTimeout(() => {
				PhotoEditor.initCrop();
			}, 200);
		}, (error) => {
			this.handleFileError(error);
		});
	},

	// Upload an image with all the details fleshed out.
	// params consist of:
	// picid   (string) - ID of the picture.
	// albumid (string) - Album ID of the picture.
	//	crop			 (obj) - Crop as provided by PhotoEdit.submitCrop().
	//	caption (string) - Optional caption for the image.
	// cb	(function) - Function to call after details are uploaded.
	// newPhoto  (bool) - Whether or not it's a new photo.
	uploadDetails(params) {
		if (!params.picid) {
			return false;
		}

		let data = {
			userid: Context.get("userid"),
			albumid: params.albumid || this.albumid,
			picid: params.picid,
			okc_api: 1,
		};

		// Fuck if I know what these are for.
		if (params.newPhoto) {
			data.use_new_upload = 1;
			if (data.albumid) {
				data["status"] = 10;
				data["picture.add_pic_album_ajax"] = 1;
			} else {
				data["picture.add_ajax"] = 1;
			}
		} else {
			data["picture.update_ajax"] = 1;
		}

		if (params.width && params.height) {
			data.width = params.width;
			data.height = params.height;
		}

		// Crop data comes from PhotoEdit.submitCrop().
		if (params.crop) {
			data.tn_upper_left_x = params.crop.left;
			data.tn_upper_left_y = params.crop.top;
			data.tn_lower_right_x = params.crop.right;
			data.tn_lower_right_y = params.crop.bottom;
		}

		// If an empty string is passed, save an empty caption.
		if (params.caption != null) {
			data.caption = params.caption;
		}

		OkPhotos.showLoader();

		OkC.legacy("/photoupload", {
			data,

			success: response => {
				return typeof params.cb === "function"
					? params.cb(response, data)
					: undefined;
			},
		});
	},

	tileScroll_cb(tiles) {
		PhotoTiles.hideLoader();

		if (!tiles.length) {
			PhotoTiles.endOfTiles = true;
		}
	},

	// change the photo rules if you're uploading to the "More photos" album
	setRules(activeAlbum) {
		if (!(this.rules != null ? this.rules.length : undefined)) {
			return;
		}

		if (!this.ruleTypes[activeAlbum]) {
			return;
		}

		let c = "isMorePhotos";

		if (activeAlbum === this.ruleTypes.album || activeAlbum === this.ruleTypes.STORIES_ESSAY_ATTACHMENTS) {
			this.rules.addClass(c);
		} else if (activeAlbum === this.ruleTypes.profile) {
			this.rules.removeClass(c);
		}
	},
};



// WEBPACK FOOTER //
// ./src/legacy/okphotos/photouploader.js